module.exports = __webpack_public_path__ + "static/media/image.3ad16e0c.svg";